import AccountContext from 'context/AccountContext';
import { hasAcceptedTerms } from 'hooks/useHasAcceptance';
import { useContext } from 'react';
import { useAuthStore } from 'stores/authStore';
import { CountryCode } from 'types/generatedSchemaTypes';

const useIsLoggedIn = () => {
  const { customer, loading } = useContext(AccountContext);
  const token = useAuthStore((state) => state.accessToken);
  return {
    loginLoading: loading ?? false,
    isLoggedIn: !!customer?.accountType && !!token,
    customerUid: customer.uid,
    hasAcceptedTermsCustomerCountry:
      !!customer.uid &&
      hasAcceptedTerms(
        customer.countryCode as CountryCode,
        'TERMS_ACCEPTED',
        customer.acceptances
      ),
  };
};

export default useIsLoggedIn;
